import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a6b9866e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a6b9866e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b9866e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b9866e')) {
      api.createRecord('a6b9866e', component.options)
    } else {
      api.reload('a6b9866e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a6b9866e&scoped=true&", function () {
      api.rerender('a6b9866e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYR2oHuJ35SY/JS/comp/GuestBox.vue"
export default component.exports